import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export const accreditationLogosCarousel = (selector) => {
    jQuery(document).ready(function ($) {
        new Splide( selector, {
            type   : 'loop',
            focus  : 'center',
            drag   : false,
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            perPage: 6,
            gap: '100px',
            fixedWidth: '190px',
            height: '140px',
            autoScroll: {
                speed: 0.5,
                pauseOnHover: false,
                pauseOnFocus: false
            },
            breakpoints: {
                1400: {
                    perPage: 4,
                    gap: '80px'
                },
                992: {
                    perPage: 3,
                    gap: '40px'
                },
                768: {
                    perPage: 2,
                    gap: '40px',
                    fixedWidth: '133px',
                    height: '98px'
                }
            }
        }).mount({AutoScroll});
    });
};